import { render, staticRenderFns } from "./AssetImage.vue?vue&type=template&id=4af39fc4&scoped=true&"
import script from "./AssetImage.vue?vue&type=script&lang=ts&"
export * from "./AssetImage.vue?vue&type=script&lang=ts&"
import style0 from "./AssetImage.vue?vue&type=style&index=0&id=4af39fc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af39fc4",
  null
  
)

export default component.exports